var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeftSmall = function SvgArrowLeftSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.06 13.78a.495.495 0 0 0 .354-.147.503.503 0 0 0 0-.706L6.067 8.58a.82.82 0 0 1 0-1.16l4.347-4.347a.503.503 0 0 0 0-.706.503.503 0 0 0-.707 0L5.36 6.713c-.34.34-.533.8-.533 1.287 0 .487.187.947.533 1.287l4.347 4.346c.1.094.227.147.353.147Z"
  })));
};
export default SvgArrowLeftSmall;